export const CouponScopeEnum = Object.freeze({
  ALL: 'ALL',
  PLAN: 'PLAN',
  ADDON_TOTAL: 'ADDON_TOTAL',
  ADDON_ITEM: 'ADDON_ITEM',
});

export const CouponValueTypeEnum = Object.freeze({
  PERCENT: 'PERCENT',
  FIXED: 'FIXED',
});
